const BranchTypes = {
	CREATE_BRANCH_START: 'create_branch_start',
	CREATE_BRANCH_SUCCESS: 'create_branch_success',
	CREATE_BRANCH_FAILURE: 'create_branch_failure',
	UPDATE_BRANCH_START: 'update_branch_start',
	UPDATE_BRANCH_SUCCESS: 'update_branch_success',
	UPDATE_BRANCH_FAILURE: 'update_branch_failure',
	GET_BRANCHES_BY_ORGANISATION_START: 'get_branches_by_organisation_start',
	GET_BRANCHES_BY_ORGANISATION_SUCCESS: 'get_branches_by_organisation_success',
	GET_BRANCHES_BY_ORGANISATION_FAILURE: 'get_branches_by_organisation_failure',
	GET_BRANCHES_BY_ORGANISATION_KEY: 'GetAllBranchByOrganisationIDWeb',
	GET_BRANCH_BY_ID_START: 'get_branch_by_id_start',
	GET_BRANCH_BY_ID_SUCCESS: 'get_branch_by_id_success',
	GET_BRANCH_BY_ID_FAILURE: 'get_branch_by_id_failure',
	UPDATE_BRANCH_KEY: 'UpdateParticularBranchByID',
	CREATE_BRANCH_KEY: 'CreateNewBranchFromWeb',
} as const;

export default BranchTypes;
